<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="发送红包"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
       
        <el-form-item label="金额" prop="money" >  
          <el-input  type="number" v-model="formData.money" placeholder="请输入红包金额"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="mark" >  
          <el-input  type="text" v-model="formData.mark" placeholder="恭喜发财，大吉大利"></el-input>
        </el-form-item>

        <el-form-item label="支付密码" prop="pay_password" >  
          <el-input  type="text" v-model="formData.pay_password" placeholder="请输入支付密码"></el-input>
        </el-form-item>
       
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">发 送</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { chatUserAddredPack} from "@/api/chat/index.js";

export default {
  components: { },

  data() {
    return {
      visible: false,

      formData: {
        user_app_id:"",
        type: 1,//红包类型1普通，2贺卡
        money:"",
        mark:"",
        pay_password: "",
       
      },
       rules: {
          money: [
              {required: true, message: '请输入红包金额', trigger: 'blur'}
          ],
          mark: [
              {required: true, message: '请输入红包描述', trigger: 'blur'}
          ],

          pay_password: [
              {required: true, message: '请输入支付密码', trigger: 'blur'}
          ]

       }
    };
  },

 
  mounted() {

},
destroyed(){

},
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.selectedJob=null;
      this.selectedJob={};
      this.selectedAddress={};
      this.addressList=[];
      this.visible = false;

    },


    init(user_app_id) {
      console.log(user_app_id);
      this.visible = true;
      this.formData.user_app_id=user_app_id;
      
    },

   
   
    submit(){
      var that=this;
      this.$refs["form"].validate((valid) => {
          if (valid) {
            chatUserAddredPack(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
               var redpack_id=response.data.redpack_id;
                that.$emit('callback',redpack_id);
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          }
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
